export const config = {
   apiKey: "AIzaSyA9Bp3nt7764_Rco-fHAwRsld6DyWhS1B4",
   authDomain: "teamcaptain-b3334.firebaseapp.com",
   databaseURL: "https://teamcaptain-b3334.firebaseio.com",
   storageBucket: "teamcaptain-b3334.appspot.com",
   messagingSenderId: "602452524568"
 };



// WEBPACK FOOTER //
// ./src/config/config.js